import axios from "axios";
const qs = require("qs");
import Cookies from "js-cookie";
import { Message, Spin } from "view-design";
import Vue from "vue";
export const EventBus = new Vue();
axios.defaults.withCredentials = true;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";

//axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
//const base = "http://xx1878.xiaomy.net/";
export const base = "https://jxjy.api.aierxin.cn/"; //正式务器
// export const base = "http://api.aierxin.cn/"; //正式务器
// export const base = "http://127.0.0.1:1273/"; //正式务器

export const javaBase = "https://api.new.aierxin.cn/jxjyapi/"; //正式务器

export const javaBaseNew = "https://jxjy.api.aierxin.cn"; //67正式务器
export const baseUrl = 'https://api.new.aierxin.cn' //爱尔信正式服务器
// export const baseUrl = '/api' //爱尔信十点正式服务器''
export const baseNew = 'https://api.new.aierxin.cn' //爱尔信网校正式服务器
// export const baseNew = '/app' //爱尔信网校正式服务器
 // baseURL:"api",// 开发
// export const base = "http://377yf2.natappfree.cc/"; //李骏
// export const base = "http://test.276062220.cn/"; //王
// export const base = "http://121.37.247.227:1272/"; //测试务器
// export const base = "http://192.168.124.47:1272/"; //杨星
// 自定义数据加载动画函数，用到的页面将函数导入用即可
export function showLoading() {
    Spin.show({
        render: (h) => {
            return h("div", [
                h("Icon", {
                    class: "demo-spin-icon-load",
                    props: {
                        type: "ios-loading",
                        size: 18,
                    },
                }),
                h("div", "加载中..."),
            ]);
        },
    });
}
// url 路径后半部分   param参数   fali是请求不成功时特殊操作， 一般都只是给用户一个提示，已经封装在post接口里（Message.error(res.data.message)），
//如果只是一般给用户提示，就不用在页面每次调接口时都去对错误进行处理，则页面就不需要传fail
export const postData = (url, param, fali) => {
    if (localStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(localStorage.getItem("master")).token.token,
        };
    } else if (sessionStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(sessionStorage.getItem("master")).token.token,
        };
    }
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(base + url, qs.stringify(param))
                .then((res) => {
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.flag == 1) {
                            //1成功  0失败 3token失效
                            resolve(res.data);
                        } else if (res.data.flag == 3) {
                            // Message.error("token过期，请重新登录后刷新才能进行操作！");
                            setTimeout(() => {
                                // EventBus.$emit("loginOut");
                                localStorage.removeItem("master");
                                sessionStorage.removeItem("master");
                                EventBus.$emit("getToten");
                                EventBus.$emit("redirectHome");
                                EventBus.$emit("login");
                            }, 1000);
                        } else {
                            console.log("错误结果", res);
                            reject(res.data);
                            if (res.data.message == "该专题下没有相关考题") {
                                return;
                            }
                            if (res.data.message == "token不能为空") {
                                setTimeout(() => {
                                    // EventBus.$emit("loginOut");
                                    localStorage.removeItem("master");
                                    sessionStorage.removeItem("master");
                                    EventBus.$emit("getToten");
                                    EventBus.$emit("redirectHome");
                                    EventBus.$emit("login");
                                }, 1000);
                                return;
                            }

                            fali ? fali(res) : Message.error(res.data.message);
                        }
                    } else if (res.status >= 500) {
                        // EventBus.$emit("loginOut");
                        EventBus.$emit("redirectHome");
                        fali ? fali() : Message.error("服务器内部错误");
                        // reject({
                        //     flag: 0,
                        //     message: "服务器内部错误",
                        // });
                    }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    fali ? fali() : Message.error("网络错误，请联系管理员");
                    // reject({
                    //     flag: 0,
                    //     message: "网络错误，请联系管理员",
                    // });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};

// url 路径后半部分   param参数   fali是请求不成功时特殊操作， 一般都只是给用户一个提示，已经封装在post接口里（Message.error(res.data.message)），
//如果只是一般给用户提示，就不用在页面每次调接口时都去对错误进行处理，则页面就不需要传fail
export const postDataJAVA = (url, param, fali) => {
    if (localStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(localStorage.getItem("master")).token.token,
        };
    } else if (sessionStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(sessionStorage.getItem("master")).token.token,
        };
    }
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(javaBaseNew + url, qs.stringify(param))
                .then((res) => {
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.flag == 1) {
                            //1成功  0失败 3token失效
                            resolve(res.data);
                        } else if (res.data.flag == 3) {
                            // Message.error("token过期，请重新登录后刷新才能进行操作！");
                            setTimeout(() => {
                                // EventBus.$emit("loginOut");
                                localStorage.removeItem("master");
                                sessionStorage.removeItem("master");
                                EventBus.$emit("getToten");
                                EventBus.$emit("redirectHome");
                                EventBus.$emit("login");
                            }, 1000);
                        } else {
                            console.log("错误结果", res);
                            reject(res.data);
                            if (res.data.message == "该专题下没有相关考题") {
                                return;
                            }
                            if (res.data.message == "token不能为空") {
                                setTimeout(() => {
                                    // EventBus.$emit("loginOut");
                                    localStorage.removeItem("master");
                                    sessionStorage.removeItem("master");
                                    EventBus.$emit("getToten");
                                    EventBus.$emit("redirectHome");
                                    EventBus.$emit("login");
                                }, 1000);
                                return;
                            }

                            fali ? fali(res) : Message.error(res.data.message);
                        }
                    } else if (res.status >= 500) {
                        // EventBus.$emit("loginOut");
                        EventBus.$emit("redirectHome");
                        fali ? fali() : Message.error("服务器内部错误");
                        // reject({
                        //     flag: 0,
                        //     message: "服务器内部错误",
                        // });
                    }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    fali ? fali() : Message.error("网络错误，请联系管理员");
                    // reject({
                    //     flag: 0,
                    //     message: "网络错误，请联系管理员",
                    // });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};



// url 路径后半部分   param参数   fali是请求不成功时特殊操作， 一般都只是给用户一个提示，已经封装在post接口里（Message.error(res.data.message)），
//如果只是一般给用户提示，就不用在页面每次调接口时都去对错误进行处理，则页面就不需要传fail
export const postDataJavaNew = (url, param, fali) => {
    if (localStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(localStorage.getItem("master")).token.token,
        };
    } else if (sessionStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(sessionStorage.getItem("master")).token.token,
        };
    }
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(javaBase + url, qs.stringify(param))
                .then((res) => {
                    // console.log(res)
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.code == true ||res.data.code == 1 ||res.data.flag==1) {
                            //1成功  0失败 3token失效

                            resolve(res.data);

                        } else {


                            fali ? fali(res) : Message.error(res.data.msg ?? res.data.message);
                            resolve(res.data);

                        }
                    } else if (res.status >= 500) {
                        // EventBus.$emit("loginOut");
                        EventBus.$emit("redirectHome");
                        fali ? fali() : Message.error("服务器内部错误");

                    }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    fali ? fali() : Message.error("网络错误，请联系管理员");

                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};
export const postDataJxjy = (url, param, fali) => {
    if (localStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(localStorage.getItem("master")).token.token,
        };
    } else if (sessionStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(sessionStorage.getItem("master")).token.token,
        };
    }
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(baseUrl + url, qs.stringify(param))
                .then((res) => {
					console.log(res,'postDataJxjy')
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.code == 1) {
                            //1成功  0失败 3token失效
							
                            resolve(res.data);
							// console.log(res.data);
                        } else if (res.data.code == 0) {
                            console.log(123)
                            fali ? fali(res) : Message.error(res.data.msg ?? res.data.message);
                            // Message.error(res.data.msg);
                            resolve(res.data);
                            // setTimeout(() => {
                            //     // EventBus.$emit("loginOut");
                            //     localStorage.removeItem("master");
                            //     sessionStorage.removeItem("master");
                            //     EventBus.$emit("getToten");
                            //     EventBus.$emit("redirectHome");
                            //     EventBus.$emit("login");
                            // }, 1000);
                        } else {
                            resolve(res.data);
                            // fali ? fali(res) : Message.error(res.data.msg);
                        }
                    } else if (res.status >= 500) {
                        // EventBus.$emit("loginOut");
                        EventBus.$emit("redirectHome");
                        fali ? fali() : Message.error(res.data.msg);
                        // reject({
                        //     flag: 0,
                        //     message: "服务器内部错误",
                        // });
                    }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    // fali ? fali() : Message.error("网络错误，请联系管理员");
                    // reject({
                    //     flag: 0,
                    //     message: "网络错误，请联系管理员",
                    // });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};
export const postDataNew = (url, param, fali) => {
    if (localStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(localStorage.getItem("master")).token.token,
        };
    } else if (sessionStorage.getItem("master")) {
        param = {
            ...param,
            token: JSON.parse(sessionStorage.getItem("master")).token.token,
        };
    }
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(baseNew + url, qs.stringify(param))
                .then((res) => {
					// console.log(res)
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.code == true ||res.data.code == 1) {
                            //1成功  0失败 3token失效
							
                            resolve(res.data);
							// console.log(res.data);
                        } else {
                            // Message.error(res.data.msg);
							fali ? fali(res) : Message.error(res.data.msg ?? res.data.message);
							 resolve(res.data);
                           
                        } 
                    } else if (res.status >= 500) {
                        // EventBus.$emit("loginOut");
                        EventBus.$emit("redirectHome");
                        fali ? fali() : Message.error("服务器内部错误");
                        // reject({
                        //     flag: 0,
                        //     message: "服务器内部错误",
                        // });
                    }
                    console.log(res,999)
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {

                    console.log(err,888 )

                    Spin.hide();
                    reject({
                        flag: 0,
                        message: "网络错误，请联系管理员",
                    });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};
export const postUpload = (url, param, fali) => {
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(base + url, param)
                .then((res) => {
                    if (res.status >= 200 && res.status < 500) {
                        if (res.data.flag == 1) {
                            //1成功  0失败
                            resolve(res.data);
                        } else if (res.data.flag == 3) {
                            // Message.error("token过期，请重新登录后才能进行操作！");
                            setTimeout(() => {
                                // EventBus.$emit("loginOut");
                                localStorage.removeItem("master");
                                sessionStorage.removeItem("master");
                                EventBus.$emit("getToten");
                                EventBus.$emit("redirectHome");
                                EventBus.$emit("login");
                            }, 1000);
                        } else {
                            console.log("错误结果", res);
                            Message.error(res.data.message);
                            reject(res.data);
                        }
                    } else if (res.status >= 500) {
                        Message.error("服务器内部错误");
                        reject({
                            flag: 0,
                            message: "服务器内部错误",
                        });
                    }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    Message.error("网络错误，请联系管理员");
                    reject({
                        flag: 0,
                        message: "网络错误，请联系管理员",
                    });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};

export const postUploadNew = (url, param, fali) => {
    return Promise.race([
        new Promise((resolve, reject) => {
            axios
                .post(baseNew + url, param)
                .then((res) => {
                    resolve(res.data);
                    // if (res.status >= 200 && res.status < 500) {
                    //     if (res.data.flag == 1) {
                    //         //1成功  0失败
                    //         resolve(res.data);
                    //     } else if (res.data.flag == 3) {
                    //         // Message.error("token过期，请重新登录后才能进行操作！");
                    //         setTimeout(() => {
                    //             // EventBus.$emit("loginOut");
                    //             localStorage.removeItem("master");
                    //             sessionStorage.removeItem("master");
                    //             EventBus.$emit("getToten");
                    //             EventBus.$emit("redirectHome");
                    //             EventBus.$emit("login");
                    //         }, 1000);
                    //     } else {
                    //         console.log("错误结果", res);
                    //         Message.error(res.data.message);
                    //         reject(res.data);
                    //     }
                    // } else if (res.status >= 500) {
                    //     Message.error("服务器内部错误");
                    //     reject({
                    //         flag: 0,
                    //         message: "服务器内部错误",
                    //     });
                    // }
                    Spin.hide(); //统一关闭加载loding动画
                })
                .catch((err) => {
                    Spin.hide();
                    Message.error("网络错误，请联系管理员");
                    reject({
                        flag: 0,
                        message: "网络错误，请联系管理员",
                    });
                });
        }),
        new Promise((resolve, reject) => {
            var timerOut = {
                flag: 0,
                message: "请求超时 " + url,
            };
            setTimeout(() => {
                // reject(timerOut);
            }, 50000);
        }),
    ]);
};
// //get
// export const getData = (getUrl,data, globeVue) => {
// 	return Promise.race([
// 		new Promise((resolve, reject) => {
// 			axios.get(base + getUrl,data)
// 				.then((response) => {
// 					/*
// 					//登录状态
// 					if(response.data.state == 401) {
// 						Cookies.set('token', '');
// 						// 退出登录
// 						globeVue.$router.push({
// 							name: 'login'
// 						});
// 						resolve({
// 							state: 0,
// 							msg: "重新登陆"
// 						});
// 					} //无法进入
// 					else */
// 					if(response.data.flag != 1) {
// 						var timerOut = {
// 							"state": 0,
// 							"msg": response.data.message
// 						}
// 						resolve(timerOut);
// 					} else {
// 						resolve(response.data);
// 					}
// 				})
// 				.catch((error) => {
// 					resolve({
// 						state: 0,
// 						msg: "网络错误，请联系管理员"
// 					});
// 				});
// 		}),
// 		new Promise((resolve, reject) => {
// 			var timerOut = {
// 				"state": 0,
// 				"msg": "请求超时"
// 			}
// 			setTimeout(() => {
// 				resolve(timerOut);
// 			}, 50000);
// 		})
// 	])
// }
// //post
// //globeVue 全局vue对象
// export const postData = (postUrl, param, globeVue) => {

// 	return Promise.race([
// 		new Promise((resolve, reject) => {
// 			//每次调用接口必须带上systems字段名，例如systems:admin或systems:system
// 			axios.post(base + postUrl, param)
// 				.then((response) => {
// 					//登录状态
// 					if(response.data.state == 401) {
// 						// 退出登录
// 						globeVue.$router.push({
// 							name: 'login'
// 						});
// 						resolve({
// 							state: 0,
// 							msg: "重新登陆"
// 						});
// 					}
// 					//无法进入
// 					else if(response.data.state != 200) {
// 						var timerOut = {
// 							"state": 0,
// 							"msg": response.data.msg
// 						}
// 						resolve(timerOut);
// 					} else {
// 						resolve(response.data);
// 					}
// 				})
// 				.catch((error, response) => {
// 					resolve({
// 						state: 0,
// 						msg: "网络错误，请联系管理员"
// 					});
// 				});
// 		}),
// 		new Promise((resolve, reject) => {
// 			var timerOut = {
// 				"state": 0,
// 				"msg": "请求超时" + postUrl
// 			}
// 			setTimeout(() => {
// 				resolve(timerOut);
// 			}, 50000);
// 		})
// 	])
// }